module.exports = __webpack_public_path__ + "img/blue_138.14ea1100.png";